const Decrease = ({Decrease}) => {

    return <>
        <button onClick={Decrease}>
            -
        </button>
    </>
}


export default Decrease